import { render, staticRenderFns } from "./PartnershipsMap.vue?vue&type=template&id=4b749682&scoped=true&"
import script from "./PartnershipsMap.vue?vue&type=script&setup=true&lang=js&"
export * from "./PartnershipsMap.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b749682",
  null
  
)

export default component.exports